import { useTranslation } from "react-i18next"
import QRCode from "react-qr-code"
import type { Theme } from "@mui/material"
import { Stack, Typography, List, ListItem, useMediaQuery, useTheme } from "@mui/material"

import type { UserOTPRegisterRes } from "types/users.types"
import PopUp from "widgets/common/PopUp"
import OTPVerifier from "./OTPVerifier"

interface OTPRegisterModalProps {
  open: boolean
  onClose: () => void
  onComplete: () => Promise<void>
  username: string
  accessToken?: string
  data: UserOTPRegisterRes | undefined
}

const OTPRegisterModal = ({
  open,
  onClose,
  onComplete,
  username,
  accessToken,
  data,
}: OTPRegisterModalProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"))

  if (data === undefined) {
    return <></>
  }
  return (
    <PopUp
      open={open}
      onClose={onClose}
      titleKey="account_settings.TWO_FA"
      aria-describedby="otp-register-description"
      fullWidth
      maxWidth={"md"}
    >
      <Stack id="otp-register-description" width={"100%"}>
        <Typography variant="h5" component="h5" mb={1}>
          {t("account_settings.CONFIGURING_OTP")}
        </Typography>
        <List
          dense
          sx={{
            listStyleType: "disc",
            listStylePosition: "inside",
          }}
        >
          <ListItem sx={{ display: "list-item" }}>
            {t("account_settings.INSTALL_APP")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            {t("account_settings.IN_THE_AUTH_APP")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            {t("account_settings.SELECT_SCAN")}
          </ListItem>
        </List>
      </Stack>
      {data?.auth_url && (
        <Stack alignItems={"center"} my={2}>
          <QRCode
            value={data.auth_url}
            size={isMobile ? 130 : 170}
            bgColor={theme.palette.background.paper}
            fgColor={theme.palette.text.primary}
          />
        </Stack>
      )}
      <Typography
        id="otp-verification-title"
        variant="h5"
        component="h5"
        mb={1}
        align="center"
      >
        {t("account_settings.VERIFICATION_CODE")}
      </Typography>
      <OTPVerifier
        username={username}
        accessToken={accessToken}
        onComplete={onComplete}
      />
    </PopUp>
  )
}
export default OTPRegisterModal
